import { browserStorage, type StorageLike } from './clock';
import type { FeedbackDraft } from './feedbackReport';

const KEY = 'threadbound.feedback.queue.v1';
const MAX_QUEUED = 20;

let storage: StorageLike = browserStorage();

export function useFeedbackStorage(next: StorageLike): void {
  storage = next;
}

export function queueFeedback(report: FeedbackDraft): void {
  const queued = readFeedbackQueue();
  const stored: FeedbackDraft = { ...report, screenshotDataUrl: null };
  queued.push(stored);
  write(queued.slice(-MAX_QUEUED));
}

export function readFeedbackQueue(): FeedbackDraft[] {
  const raw = storage.getItem(KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as FeedbackDraft[];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item) => item && (item.kind === 'bug' || item.kind === 'idea') && typeof item.message === 'string');
  } catch {
    return [];
  }
}

export async function flushFeedbackQueue(send: (report: FeedbackDraft) => Promise<void>): Promise<void> {
  const queued = readFeedbackQueue();
  const left: FeedbackDraft[] = [];
  let blocked = false;
  for (const report of queued) {
    if (blocked) {
      left.push(report);
      continue;
    }
    try {
      await send(report);
    } catch (error) {
      const message = error instanceof Error ? error.message : '';
      if (message.includes('duplicate') || message.includes('23505')) continue;
      blocked = true;
      left.push(report);
    }
  }
  write(left);
}

function write(reports: FeedbackDraft[]): void {
  if (reports.length === 0) {
    storage.removeItem(KEY);
    return;
  }
  storage.setItem(KEY, JSON.stringify(reports));
}
